// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nkgu","questions":"styles_questions__3g7lN","footer":"styles_footer__Qv2Jk"};